import AuthGateway from '../components/auth/AuthGateway'
import AdminController from '../components/admin/AdminController'
import AdminGateway from '../components/admin/AdminGateway'
import ApplicationsController from '../components/admin/applications/ApplicationsController'
import Users from '../components/admin/users/Users'
import Clients from '../components/admin/clients/Clients'
import Invitations from '../components/admin/invitations/Invitations'
import Invite from '../components/admin/invitations/Invite'
import ScopesController from '../components/admin/oauth/ScopesController'
import SettingsController from '../components/admin/settings/SettingsController'
import User from '../components/admin/users/User'
import Versions from '../components/admin/applications/Versions'

export default [
  {
    path: 'admin',
    element: <AuthGateway />,
    children: [
      {
        element: <AdminGateway />,
        children: [
          {
            path: '',
            element: <AdminController />
          },
          {
            path: 'users',
            element: <Users />
          },
          {
            path: 'clients',
            element: <Clients />
          },
          {
            path: 'invites',
            element: <Invitations />
          },
          {
            path: 'invites/:id/edit?',
            element: <Invite />
          },
          {
            path: 'users/:id',
            element: <User />
          },
          {
            path: 'applications',
            element: <ApplicationsController />
          },
          {
            path: 'applications/:id/versions',
            element: <Versions />
          },
          {
            path: 'oauth-scopes',
            element: <ScopesController />
          },
          {
            path: 'settings',
            element: <SettingsController />
          }
        ]
      }
    ]
  }
]
